import { LicenseUploadRequest } from "@preferredMedical/Models/Shipping/LicenseUploadRequest";

const licenseUploadUrl = "/api/v1/Shipping/LicenseUpload";

export function sendLicenseUploadRequest(model: LicenseUploadRequest): Promise<Response> {
    const formData = new FormData();

    formData.append("contactName", model.contactName);
    formData.append("contactEmail", model.contactEmail);
    formData.append("phoneNumber", model.contactNumber);
    formData.append("companyName", model.companyName);
    formData.append("customerNumber", model.customerNumber);
    formData.append("additionalComments", model.additionalComments);

    model.emailTos.forEach(email => {
        formData.append("emailTos", email);
    });

    model.files.forEach(file => {
        formData.append("files", file, file.name);
    });

    return fetch(licenseUploadUrl, {
        method: "POST",
        body: formData
    });
}